<template>
  <div>
    <div v-if="adDialogVisible" class="shade">
      <div class="ad_ct">
        <a :href="guanggao.target_url" target="_blank">
          <img :src="guanggao.pic_url" alt="">
        </a>

        <i class="el-icon-circle-close" @click="adDialogVisible = false"></i>
      </div>
    </div>

    <template v-if="member.member_type === 0">
      <!--医生-->
      <doctor-home></doctor-home>
    </template>
    <template v-if="member.member_type === 1">
      <!--导师-->
      <mentor-home></mentor-home>
    </template>
    <template v-if="member.member_type === 2">
      <!--业务员-->
      <sales-home></sales-home>
    </template>
    <template v-if="member.member_type === 3">
      <!--客服-->
      <customer-home></customer-home>
    </template>
    <template v-if="member.member_type === 4">
      <!--技师-->
      <technician-home></technician-home>
    </template>
  </div>
</template>

<script>
import DoctorHome from "@/views/home/doctor";
import MentorHome from "@/views/home/mentor";
import CustomerHome from "@/views/customer_home/index";
import TechnicianHome from "@/views/technician_home";
import SalesHome from "@/views/sales_home";
import {getBanner} from "@/http/banner";

export default {
  name: "index",
  components: {SalesHome, TechnicianHome, CustomerHome, MentorHome, DoctorHome},
  data() {
    return {
      member: {},

      adDialogVisible: false,
      guanggao: {},

      fromPath: "",// 从哪里页面路径过来的
    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      // console.log('to', to)
      // console.log('from', from)
      vm.fromPath = from.path
      if (from.path === '/login') {
        // 获取首页开屏广告
        vm.getBanner(2);
      }
    })
  },
  created() {
    this.member = JSON.parse(localStorage.getItem('member'))
  },
  mounted() {

  },
  methods: {
    getBanner(bannerId) {
      getBanner({
        banner_id: bannerId
      }).then(res => {
        this.guanggao = res.data[0];
        this.adDialogVisible = !!this.guanggao.pic_url;
      });
    },
  },
}
</script>
<style scoped src="../../assets/css/home.css"></style>
<style scoped>
.shade {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100;
}

.ad_ct {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  width: 600px;
}

.ad_ct a {
  font-size: 0;
  width: 100%;
}
.ad_ct img {
  width: 100%;
}

.ad_ct .el-icon-circle-close {
  color: #fff;
  font-size: 30px;
  margin-top: 20px;
  cursor: pointer;
}
</style>
